import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTheme } from '@mui/material/styles';

export const ReactHookFormInput = ({
  type,
  id,
  name,
  control,
  error = false,
  label = '',
  placeholder = '--- SELECCIONE ---',
  disabled = false,
  readOnly = false,
  ...inputProps
}) => {
  const height = 44;
  const externalError = error;
  // Opcional (retrocompatible): maxLength limita el input y muestra un contador "n/max" bajo el campo, a la derecha.
  const maxLength = inputProps.maxLength;
  const theme = useTheme();
  const [items, setItems] = useState([]);
  const [blocking, setBlocking] = useState(true);
  const defaultOption = { value: 0, label: placeholder, isDisabled: true };

  return (
    <div style={{ marginTop: 3 }}>
      <FormControl fullWidth>
        <Controller
          render={({ field: { onChange, onBlur, value }, fieldState: { error }, formState }) => (
            <>
              <TextField
                type={type}
                size="medium"
                error={!!error}
                onChange={evt => {
                  if (inputProps.onChangeExternal) {
                    inputProps.onChangeExternal(evt, onChange);
                  } else {
                    onChange(evt);
                  }
                }}
                onBlur={evt => {
                  try {
                    if (typeof onBlur === 'function') {
                      onBlur(evt);
                    }
                  } finally {
                    if (typeof inputProps.onBlurExternal === 'function') {
                      inputProps.onBlurExternal(evt);
                    }
                  }
                }}
                value={value ?? ''}
                fullWidth
                label={label}
                variant="outlined"
                multiline={inputProps.multiline || false}
                minRows={inputProps.minRows}
                disabled={disabled}
                style={inputProps.multiline ? {} : { height }}
                InputLabelProps={{
                  style: {
                    height,
                  },
                }}
                InputProps={{
                  readOnly: readOnly,
                }}
                inputProps={{
                  ...(inputProps.minRows
                    ? {}
                    : {
                        style: {
                          height,
                          padding: '0px 14px',
                          margin: '0px 0px 0px 0px',
                        },
                      }),
                  ...(maxLength ? { maxLength } : {}),
                }}
                FormHelperTextProps={{ style: { fontSize: 9, paddingLeft: 0 } }}
              />
              {maxLength ? (
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginTop: 4, fontSize: 12, lineHeight: '16px' }}>
                  <span style={{ color: '#D92D20' }}>{(error && error.message) || (externalError && externalError.message) || ''}</span>
                  <span
                    style={{
                      color: String(value ?? '').length >= maxLength ? '#D92D20' : '#6c757d',
                      whiteSpace: 'nowrap',
                      marginLeft: 'auto',
                    }}>
                    {`${String(value ?? '').length}/${maxLength}`}
                  </span>
                </div>
              ) : null}
            </>
          )}
          control={control}
          name={name}
        />
        {!maxLength && error && <div className="invalid-feedback">{error.message}</div>}
      </FormControl>
    </div>
  );
};
